import { isNil } from "ramda"
import React, { useCallback, useEffect, useMemo, useState } from "react"
import { Form, useForm } from "react-final-form"

import { Dialog } from "../dialog/index.jsx"

export const StepsDialog = ({
  children,
  closeHandler = () => {},
  initialFormState = {},
  mutators = {},
  open = false,
  submitEvent = () => {},
  title = null,
  width = false,
  onStepChange = () => {},
}) => {
  const [step, setStep] = useState(0)

  useEffect(() => {
    if (open) setStep(0)
  }, [open])

  const setStepFunction = useCallback((step) => {
    onStepChange(step)
    setStep(step)
  }, [])

  const childrenProps = useMemo(
    () => ({
      closeHandler,
      setStep: setStepFunction,
      step,
      totalSteps: children?.length || 0,
    }),
    [initialFormState, step, children.length],
  )

  return (
    <Dialog
      open={open}
      renderButtons={false}
      onBackdropClick={closeHandler}
      title={title}
      overflow={true}
      width={width}
      showClose={true}
      onClose={closeHandler}>
      {useMemo(
        () => (
          <Form
            initialValues={initialFormState}
            mutators={mutators}
            onSubmit={submitEvent}
            render={(props) => (
              <FormComponent open={open} initialFormState={initialFormState}>
                {children
                  ?.filter((item) => !isNil(item))
                  .map((item, index) => (
                    <div key={index} style={{ display: index === step ? "block" : "none" }}>
                      {React.cloneElement(item, {
                        ...item.props,
                        ...childrenProps,
                        ...props,
                      })}
                    </div>
                  ))}
              </FormComponent>
            )}></Form>
        ),
        [width, title, initialFormState, step, open, children.length, submitEvent],
      )}
    </Dialog>
  )
}

const FormComponent = ({ children, initialFormState, open }) => {
  const { restart } = useForm()

  useEffect(() => {
    if (open) return

    restart(initialFormState)
  }, [open])

  return <form>{children}</form>
}
